import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.LOGIN.REQUEST, saga.login);
    yield takeLatest(ACTION.LOGIN.SUCCESS, saga.onLoginSuccess);
    yield takeLatest(ACTION.LOGIN.FAILED, saga.onLoginFailed);
}
